export default __webpack_public_path__ + "static/media/q1_step2_5.90097cac.png";